import { makeStyles } from '@material-ui/core/styles'

const BP990 = 990

const useStyles = makeStyles((theme) => ({
  statisticsCallout: {
    background: theme.palette.background.paper,
    padding: theme.spacing(4),
    paddingBottom: theme.spacing(8), // temp
    maxWidth: 1440,
    margin: '0 auto',
    [theme.breakpoints.up(BP990)]: {
      display: 'flex',
      flexDirection: 'row',
    },
  },
  copyContainer: {
    [theme.breakpoints.up(BP990)]: {
      width: 300,
      marginRight: 18,
    },
  },
  heading: {
    ...theme.typography.h2,
    color: theme.palette.secondary.light,
    fontSize: '1.375rem !important',
    marginBottom: 4,
    marginTop: 12,
    [theme.breakpoints.up('md')]: {
      fontSize: '2rem !important',
    },
  },
  supportiveCopy: {
    marginBottom: 10,
  },
  calloutList: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    [theme.breakpoints.up(BP990)]: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
  },
  calloutListItem: {
    padding: '30px 0',
    borderBottom: '1px solid #d8d8d8',
    '&:last-child': {
      borderBottom: 'none',
    },
    [theme.breakpoints.up(BP990)]: {
      height: 102,
      borderBottom: 'none',
      borderRight: '1px solid #d8d8d8',
      padding: '0 30px 0 40px',
      '&:last-child': {
        borderRight: 'none',
      },
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  calloutItem: { // h4
    display: 'flex',
    margin: 0,
    '& > div': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  calloutShape: {
    ...theme.typography.h5,
    height: '4.75rem',
    flex: '0 0 4.75rem',
    borderRadius: '50%',
    background: theme.palette.gold.main,
    marginRight: 20,
  },
  calloutCopy: {
    ...theme.typography.navigation,
    color: '#6A6A6A',
  },
}))

export default useStyles
